import { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { Appointment } from '../../types';

/**
 * Service for appointment-related API calls
 */
export const appointmentService = {
  /**
   * Get appointments for a device
   * @param deviceId - The device ID
   */
  getAppointments: (deviceId: string): Promise<AxiosResponse<Appointment[]>> => {
    return apiClient.get(`/api/devices/${deviceId}/appointments`);
  },

  /**
   * Create a new appointment
   * @param deviceId - The device ID
   * @param appointment - The appointment data
   */
  createAppointment: (
    deviceId: string,
    appointment: Appointment,
  ): Promise<AxiosResponse<Appointment>> => {
    return apiClient.post(`/api/devices/${deviceId}/appointments`, appointment);
  },

  /**
   * Update an existing appointment
   * @param deviceId - The device ID
   * @param appointmentId - The appointment ID
   * @param appointment - The updated appointment data
   */
  updateAppointment: (
    deviceId: string,
    appointmentId: string,
    appointment: Appointment,
  ): Promise<AxiosResponse<Appointment>> => {
    return apiClient.put(`/api/devices/${deviceId}/appointments/${appointmentId}`, appointment);
  },

  /**
   * Delete an appointment
   * @param deviceId - The device ID
   * @param appointmentId - The appointment ID
   */
  deleteAppointment: (deviceId: string, appointmentId: string): Promise<AxiosResponse> => {
    return apiClient.delete(`/api/devices/${deviceId}/appointments/${appointmentId}`);
  },
};
